import { Map } from 'immutable';
import { provincesListActions } from './actions';
import { createProvincesList } from './provinces-list';

export const initialState = new Map({
  currentProvincesListId: null
});

export const provincesListReducer = (state =  initialState  , {payload, type} ) => {
//console.log(payload, type)
  switch (type) {
    case provincesListActions.FETCH_PROVINCES_SUCCESS:
      return state.withMutations(provinceslist => {
          provinceslist.set(payload.id, createProvincesList(payload));
      });
    case provincesListActions.LOAD_PROVINCES:
      return state.set('currentProvincesListId', payload.id);

    default:
      return state;
  }
}
